__turbopack_context__.v({
  "chevronIcon": "uvdNkG_chevronIcon",
  "closeButton": "uvdNkG_closeButton",
  "collapsibleContent": "uvdNkG_collapsibleContent",
  "collapsibleInner": "uvdNkG_collapsibleInner",
  "descriptionSection": "uvdNkG_descriptionSection",
  "descriptionText": "uvdNkG_descriptionText",
  "detailItem": "uvdNkG_detailItem",
  "detailsList": "uvdNkG_detailsList",
  "divider": "uvdNkG_divider",
  "footerButton": "uvdNkG_footerButton",
  "groupTitle": "uvdNkG_groupTitle",
  "groupedDetails": "uvdNkG_groupedDetails",
  "headerInfo": "uvdNkG_headerInfo",
  "headerPrice": "uvdNkG_headerPrice",
  "headerSection": "uvdNkG_headerSection",
  "modalContainer": "uvdNkG_modalContainer",
  "modalContent": "uvdNkG_modalContent",
  "productName": "uvdNkG_productName",
  "sectionHeader": "uvdNkG_sectionHeader",
  "sectionTitle": "uvdNkG_sectionTitle",
  "shippingInfo": "uvdNkG_shippingInfo",
  "stickyFooter": "uvdNkG_stickyFooter",
  "thumbnailContainer": "uvdNkG_thumbnailContainer",
});
